import { motion } from "framer-motion";
import { ArrowRight, Send } from "lucide-react";

export default function FinalCTA() {
  return (
    <section
      data-testid="final-cta-section"
      className="relative py-24 md:py-36 bg-[var(--sci-teal)] text-white overflow-hidden"
    >
      <div className="absolute inset-0 bg-grid-dark opacity-30 pointer-events-none" />
      <div
        className="absolute -left-32 -top-32 w-[420px] h-[420px] rounded-full pointer-events-none"
        style={{
          background:
            "radial-gradient(closest-side, rgba(255,255,255,0.18), transparent)",
        }}
      />

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.8 }}
          className="grid lg:grid-cols-12 gap-10 items-end"
        >
          <div className="lg:col-span-8">
            <div className="overline text-white/70 mb-6">
              · Submit · Publish · Disseminate
            </div>
            <h2 className="font-serif-display text-4xl md:text-6xl lg:text-7xl tracking-tight leading-[0.98]">
              Share your research <br />
              with the <em className="not-italic">world</em>.
            </h2>
            <p className="mt-8 text-white/80 text-base md:text-lg leading-relaxed max-w-2xl">
              Join an international community of clinicians, surgeons, and
              researchers dedicated to advancing medical science through
              rigorous, open-access publishing.
            </p>
          </div>

          <div className="lg:col-span-4 flex flex-col gap-4 lg:items-end">
            <a
              href="#submit"
              data-testid="final-cta-submit"
              className="btn-on-dark inline-flex items-center justify-center gap-2 px-7 py-4 text-sm tracking-wide w-full lg:w-auto"
            >
              <Send size={16} />
              Submit Manuscript
            </a>
            <a
              href="#journals"
              data-testid="final-cta-explore"
              className="inline-flex items-center justify-center gap-2 px-7 py-4 text-sm tracking-wide border border-white/40 hover:border-white text-white/95 hover:text-white transition-colors w-full lg:w-auto"
            >
              Explore Journals
              <ArrowRight size={16} />
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
